import React, { useEffect, useState } from 'react';
import Datepicker from '../../../../components/elements/form/datepicker';
import Teaxtarea from '../../../../components/elements/form/textarea';
import Loader from '../../../../components/loader';
import createPurchaseOrderParts from './createPurchaseOrderParts';
import { usePurchaseRequestApi } from '../../../../store/api/hooks/purchaseApiHook';
import moment from 'moment';
import Button from '../../../../components/elements/button';
import toast from 'react-hot-toast';
import { showLocalDate } from '../../../../_common/functions';
import { usePurchaseOrderApi } from '../../../../store/api/hooks/purchaseOrderApiHook';
import { Link } from 'react-router-dom';
import Icon from '../../../../components/icons';
import Currency from '../../../../components/currency';
import { URLS } from '../../../../_config';

interface ViewPurchaseOrderProps {
  PoID: number;
  mode?: 'view' | 'approve';
  onCreate?: () => void;
  onCancel?: () => void;
}
interface Props {
  PoID: number;
  mode?: 'view' | 'approve';
  onCreate?: () => void;
  onCancel?: (trigger?: string | null) => void;
}

const ViewPurchaseOrder: React.FC<Props> = ({ PoID = null, mode = `view`, onCreate = () => { }, onCancel = () => { } }) => {
  const purchaseApi = usePurchaseOrderApi();
  const [lineItems, setLineItems] = useState<any[]>([]);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [po, setPo] = useState<any>(null);
  const [pofiles, setPofiles] = useState<any>([]);

  const parts_getSubTotal = () => {
    if (po && po.hasOwnProperty(`purchaseOrderItemList`) && po.purchaseOrderItemList) {
      return po.purchaseOrderItemList.reduce((total: number, item: any) => {
        const itemCost = parseFloat(item.unitPrice) || 0;
        const itemQuantity = parseFloat(item.requiredQty) || 0;
        return total + itemCost * itemQuantity;
      }, 0).toFixed(2);
    } else {
      return `0.00`;
    }
  };
  const part_getTotal = () => {
    const subTotal = Number(parts_getSubTotal());
    const taxRate = subTotal * (po?.taxRate || 0) / 100;
    return (subTotal + taxRate).toFixed(2);
  };

  const assets_getSubTotal = () => {
    if (po && po.hasOwnProperty(`purchaseOrderAsset`) && po.purchaseOrderAsset) {
      return po.purchaseOrderAsset.reduce((total: number, item: any) => {
        const itemCost = parseFloat(item.unitPrice) || 0;
        const itemQuantity = parseFloat(item.requiredQty) || 0;
        return total + itemCost * itemQuantity;
      }, 0).toFixed(2);
    } else {
      return `0.00`;
    }
  };
  const assets_getTotal = () => {
    const subTotal = Number(assets_getSubTotal());
    const taxRate = subTotal * (po?.taxRate || 0) / 100;
    return (subTotal + taxRate).toFixed(2);
  };

  const getPODetails = async () => {
    setShowLoader(true);
    var podetails: any = await new Promise((resolve, reject) => {
      purchaseApi.getOrderById({ purchaseOrderID: PoID }, (resp: any) => {
        if (resp && resp.purchaseOrderID > 0) {
          resolve(resp);
        } else {
          toast.error(`Failed to fetch Purchase Order details.`);
          reject(null);
        }
      }, (error: any) => {
        toast.error(`Failed to fetch Purchase Order details.`);
        reject(null);
      });
    }).catch((e) => {
      return null;
    });
    setShowLoader(false);
    if (podetails && podetails.hasOwnProperty(`purchaseOrderID`) > 0 && podetails.purchaseOrderID === PoID) {
      setPo(podetails);
      const pofilesresp = await new Promise((resolve, reject) => {
        purchaseApi.getFiles({ PurchaseOrderID: PoID }, (filesResp: any) => {
          console.log('Files for Purchase Order:', filesResp);
          if (filesResp && filesResp.code === 200 && filesResp.hasOwnProperty(`successful`) && filesResp.successful === true && Array.isArray(filesResp.purchaseOrderAttachmentList) && filesResp.purchaseOrderAttachmentList.length > 0) {
            //console.log("Exec yeah");
            setPofiles(filesResp.purchaseOrderAttachmentList);
            //setSavedAttachments(filesResp.purchaseOrderAttachmentList)
          }
        }, (error: any) => {
          console.error('Error fetching files for Purchase Order', error);
        });
      }).catch((err: any) => {
        return [];
      });

    }
  };

  const onSubmitAction = (statusID: number) => {
    // Validate unit prices before approval (only for approval action, statusID === 3)
    if (statusID === 3) {
      let invalidUnitPrice = false;
      
      if (po.typeID === 1 && po.purchaseOrderItemList) {
        // For parts, check unitPrice
        const invalidParts = po.purchaseOrderItemList.filter((item: any) => 
          !item.unitPrice || item.unitPrice <= 0
        );
        if (invalidParts.length > 0) {
          invalidUnitPrice = true;
        }
      } else if ((po.typeID === 2 || po.typeID === 3) && po.purchaseOrderAsset) {
        // For assets, check unitPrice
        const invalidAssets = po.purchaseOrderAsset.filter((item: any) => 
          !item.unitPrice || item.unitPrice <= 0
        );
        if (invalidAssets.length > 0) {
          invalidUnitPrice = true;
        }
      }
      
      if (invalidUnitPrice) {
        toast.error('Cannot approve: Cost of All line items must have greater than 0');
        return;
      }
    }

    const payload = {
      purchaseOrderID: PoID,
      PurchaseOrderStatusID: statusID
    };
    setShowLoader(true);
    purchaseApi.processOrder(payload, (resp: any) => {
      setShowLoader(false);
      if (resp.code === 200) {
        if (statusID === 3) {
          toast.success('Purchase Order Approved Successfully');
          onCreate();
        } else if (statusID === 4) {
          toast.success('Purchase Order Rejected Successfully');
          onCreate();
        }
      } else {
        toast.error(resp.message);
      }
    }, () => {
      setShowLoader(false);
      toast.error('Failed to process Purchase Order!');
    });
  };

  useEffect(() => {
    if (PoID) {
      getPODetails();
    }
  }, []);

  return (
    <div className={`pr-2.5`}>
      {showLoader && (
        <div className={`flex items-center justify-center p-5`}><Loader /></div>
      )}
      {!showLoader && po && (
        <div>
          <div className='flex-1 overflow-auto'>
            <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>Basic Information</h4>
            <div className={`mb-4`}>
              <div className={`font-normal text-[0.938rem] leading-none`}>PO Number</div>
              <div className={`border-[#CECECE] border rounded-md text-[0.938rem] mt-2 pl-4 py-2.5 h-[42px]  font-normal text-[#222222] w-full bg-[#F6F6F6]`}>{po.purchaseOrderCode}</div>
            </div>
            <div className={`grid grid-cols-2 gap-4`}>
              <div className={`grow mb-4`}>
                <div className={`font-normal text-[0.938rem] leading-none`}>Vendor Name</div>
                <div className={`border-[#CECECE] border rounded-md text-[0.938rem] mt-2 pl-4 py-2.5 h-[42px] font-normal text-[#222222] w-full bg-[#F6F6F6]`}>{po.vendorName}</div>
              </div>
              <div className={`grow mb-4`}>
                <div className={`font-normal text-[0.938rem] leading-none`}>Due Date</div>
                <div className={`border-[#CECECE] border rounded-md text-[0.938rem] mt-2 pl-4 py-2.5 h-[42px] font-normal text-[#222222] w-full bg-[#F6F6F6]`}>{moment.utc(po.requiredByDate).local().format(`MM/DD/YYYY`)}</div>
              </div>
            </div>
            <div className={`mb-4`}>
              <div className={`font-normal text-[0.938rem] leading-none`}>Attach Files</div>
              <div className={`text-[0.938rem] py-2 pb-0  font-normal text-[#222222] w-full`}>
                {pofiles.length > 0 && (
                  <div className={`flex items-center gap-2`}>
                    {pofiles.map((item: any, index: number) => {
                      const found = [`.png`, `.jpg`, `.jpeg`, `.webp`].some((word) => item.originalFileName.includes(word));
                      return (
                        <div key={`attachment-item-${index}`} className={`flex text-[0.813rem] text-primary text-center justify-center items-center relative w-24 h-20`}>
                          <Link to={item.fullFilePath} target="_blank">
                            {found ? (
                              <img src={item.fullFilePath} alt={item.originalFileName} className={`border border-primary rounded-md w-24 h-20 object-cover object-center`} />
                            ) : (
                              <Icon name={`attachmentfile`} size={1.3} />
                            )}
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            <div className={`mb-8`}>
              <div className={`font-normal text-[0.938rem] leading-none`}>PO Type</div>
              <div className={`border-[#CECECE] border rounded-md text-[0.938rem] mt-2 pl-4 py-2.5 h-[42px] font-normal text-[#222222] w-full bg-[#F6F6F6]`}>{po.typeName}</div>
            </div>

            {+po.typeID === 1 && (
              <div className={`mb-4`}>
                <h4 className='font-semibold text-[0.938rem] pb-5 uppercase'>ITEMS</h4>
                {/* total width 679px */}
                <div className={`border border-[#043E6133] rounded-[5px] parts-table`}>
                  <div className={`flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]`}>
                    <div className={`min-w-[150px] w-[150px] max-w-[150px] flex-shrink-0 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Item Code</div>
                    <div className={`min-w-[215px] w-[215px] max-w-[215px] flex-shrink-0 grow font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Item Name</div>
                    <div className={`min-w-[125px] w-[125px] max-w-[125px] flex-shrink-0 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Cost </div>
                    <div className={`min-w-[92px] w-[92px] max-w-[92px] flex-shrink-0 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Quantity</div>
                    <div className={`min-w-[97px] w-[97px] max-w-[97px] flex-shrink-0 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Total</div>
                  </div>
                  <div className={``}>
                    {po.purchaseOrderItemList.length === 0 && (
                      <div className={`flex items-center justify-center h-24 text-gray-500`}>
                        No parts added yet.
                      </div>
                    )}
                    {po.purchaseOrderItemList.map((part: any, index: number) => (
                      <div className={`flex items-center flex-nowrap ${index < (po.purchaseOrderItemList.length - 1) ? `border-b border-[#043E6133]` : ``}`} key={`part-item-${index}`}>
                        <div className={`min-w-[140px] w-[140px] max-w-[140px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex items-center`}>{part.partsCode || `--`}</div>
                        <div className={`min-w-[225px] w-[225px] max-w-[225px] flex-shrink-0 grow font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col`}>
                          <div className={`preview-value line-clamp-1`} title={part.partName}>{part.partName || `--`}</div>
                        </div>
                        <div className={`min-w-[125px] w-[125px] max-w-[125px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col`}>
                          <div className={`preview-value line-clamp-1 text-right`}>
                            <Currency currency={`USD`} value={part.unitPrice ? Number(part.unitPrice) : 0} />
                          </div>
                        </div>
                        <div className={`min-w-[92px] w-[92px] max-w-[92px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col`}>
                          <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                            <div className={`w-20 min-w-20 text-right`}>
                              <div className={`preview-value`}>{part.requiredQty || 0}</div>
                            </div>
                            <div>{part.unitName || ``}</div>
                          </div>
                        </div>
                        <div className={`min-w-[97px] w-[97px] max-w-[97px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col`}>
                          <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                            <div><Currency currency={`USD`} value={Number((part?.unitPrice * (part?.requiredQty || 0))?.toFixed(2) || 0)} /></div>
                          </div>
                        </div>
                      </div>
                    ))}

                    {po.purchaseOrderItemList.length != 0 && (
                      <>
                        <div className={`flex items-center flex-nowrap border-b border-[#043E6133]`} >
                          <div className={`min-w-[582px] w-[582px] max-w-[582px] flex-shrink-0 grow font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`}>
                            <div className={`preview-value line-clamp-1 text-right`} >Sub Total</div>
                          </div>
                          <div className={`w-[97px] min-w-[97px] max-w-[97px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col editable cursor-pointer`}>
                            <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                              <div><Currency currency={`USD`} value={Number(parts_getSubTotal())} /></div>
                            </div>
                          </div>
                        </div>

                        <div className={`flex items-center flex-nowrap border-b border-[#043E6133]`} >
                          <div className={`min-w-[582px] w-[582px] max-w-[582px] flex-shrink-0 grow font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`}>
                            <div className={`preview-value line-clamp-1 text-right`} >Tax</div>
                          </div>
                          <div className={`min-w-[97px] w-[97px] max-w-[97px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col editable cursor-pointer`}>
                            <div className={`flex items-center gap-1 flex-nowrap justify-end`}>{po.taxRateName || `--`}</div>
                          </div>
                        </div>
                        <div className={`flex items-center flex-nowrap`} >
                          <div className={`min-w-[582px] w-[582px] max-w-[582px] flex-shrink-0 grow font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`}>
                            <div className={`preview-value line-clamp-1 font-semibold text-right`} >Total</div>
                          </div>
                          <div className={`min-w-[97px] w-[97px] max-w-[97px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col editable cursor-pointer`}>
                            <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                              <div><Currency currency={`USD`} value={Number(part_getTotal())} /></div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

              </div>
            )}
            {(+po.typeID === 2 || +po.typeID === 3) && (
              <div className={`mb-4`}>
                <h4 className='font-semibold text-[0.938rem] pb-4 uppercase'>ITEMS</h4>
                {/* total width 679px */}
                <div className={`border border-[#043E6133] rounded-[5px] parts-table`}>
                  <div className={`flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]`}>
                    <div className={`min-w-[332px] w-[332px] max-w-[332px] flex-shrink-0 grow font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center`}>Item Name</div>
                    <div className={`min-w-[120px] w-[120px] max-w-[120px] flex-shrink-0 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Cost</div>
                    <div className={`min-w-[97px] w-[97px] max-w-[97px] flex-shrink-0 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Quantity</div>
                    <div className={`min-w-[130px] w-[130px] max-w-[130px] flex-shrink-0 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center justify-end`}>Total</div>
                  </div>
                  <div className={``}>
                    {po.purchaseOrderAsset.length === 0 && (
                      <div className={`flex items-center justify-center h-24 text-gray-500`}>
                        No assets added yet.
                      </div>
                    )}
                    {po.purchaseOrderAsset.map((asset: any, index: number) => (
                      <div className={`flex items-center flex-nowrap border-b border-[#043E6133]`} key={`asset-item-${index}`}>
                        <div className={`min-w-[332px] w-[332px] max-w-[332px] flex-shrink-0 grow font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col`}>
                          <div className={`preview-value line-clamp-1`} title={asset.assetName}>{asset.assetName || `--`}</div>
                        </div>
                        <div className={`min-w-[120px] w-[120px] max-w-[120px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col`}>
                          <div className={`preview-value text-right line-clamp-1`} ><Currency currency={`USD`} value={Number(asset.unitPrice) || 0} /></div>
                        </div>
                        <div className={`min-w-[97px] w-[97px] max-w-[97px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col`}>
                          <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                            <div className={`w-20 min-w-20 text-right`}>
                              <div className={`preview-value`}>{asset.requiredQty || 0}</div>
                            </div>
                            <div>{asset.unitCode || ``}</div>
                          </div>
                        </div>
                        <div className={`min-w-[130px] w-[130px] max-w-[130px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col`}>
                          <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                            <div><Currency currency={`USD`} value={Number((asset?.unitPrice * (asset?.requiredQty || 0))?.toFixed(2) || 0)} /></div>
                          </div>
                        </div>
                      </div>
                    ))}
                    {po.purchaseOrderAsset.length != 0 && (
                      <>
                        <div className={`flex items-center flex-nowrap border-b border-[#043E6133]`} >
                          <div className={`min-w-[549px] w-[549px] max-w-[549px] flex-shrink-0 grow font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`} >
                            <div className={`preview-value line-clamp-1`} >Sub Total</div>
                          </div>
                          <div className={`min-w-[130px] w-[130px] max-w-[130px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col editable cursor-pointer`} >
                            <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                              <div>
                                <Currency currency={`USD`} value={assets_getSubTotal()} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={`flex items-center flex-nowrap border-b border-[#043E6133]`} >
                          <div className={`min-w-[549px] w-[549px] max-w-[549px] flex-shrink-0 grow font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`} >
                            <div className={`preview-value line-clamp-1`} >Tax</div>
                          </div>

                          <div className={`min-w-[130px] w-[130px] max-w-[130px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col editable cursor-pointer`} >
                            <div className={`flex items-center gap-1 flex-nowrap justify-end`}>{po.taxRateName || `--`}</div>
                          </div>
                        </div>
                        <div className={`flex items-center flex-nowrap`} >
                          <div className={`min-w-[549px] w-[549px] max-w-[549px] flex-shrink-0 grow font-normal text-[#42484B] text-[14px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col cursor-pointer editable`} >
                            <div className={`preview-value line-clamp-1 font-semibold`} >Total</div>
                          </div>
                          <div className={`min-w-[130px] w-[130px] max-w-[130px] flex-shrink-0 font-normal text-[#42484B] text-[14px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col editable cursor-pointer`} >
                            <div className={`flex items-center gap-1 flex-nowrap justify-end`}>
                              <div><Currency currency={`USD`} value={assets_getTotal()} /></div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                  </div>
                </div>

              </div>
            )}



            <h4 className='font-semibold text-[0.938rem] pt-4 pb-4 uppercase'>Receiving Store</h4>
            <div className={`mb-4`}>
              <div className={`font-normal text-[0.938rem] leading-none`}>Location/Facility</div>
              <div className={`border-[#CECECE] border rounded-md text-[0.938rem] mt-2 pl-4 py-2.5 h-[42px] font-normal text-[#222222] w-full bg-[#F6F6F6]`}>{po.facilityName}</div>
            </div>
            <div className={`mb-4`}>
              <div className={`font-normal text-[0.938rem] leading-none`}>Notes</div>
              <div className={`border-[#CECECE] border rounded-md text-[0.938rem] mt-2 pl-4 py-2.5 min-h-[42px] font-normal text-[#222222] w-full bg-[#F6F6F6]`}>{po.notes || `--`}</div>
            </div>
            
            <div className={`mb-4`}>
              <div className={`font-normal text-[0.938rem] leading-none`}>Approved by</div>
              <div className={`border-[#CECECE] border rounded-md text-[0.938rem] mt-2 pl-4 py-2.5 h-[42px] font-normal text-[#222222] w-full bg-[#F6F6F6]`}>{po.approverName || `--`}</div>
            </div>
            <div className={`mb-4`}>
              <div className={`font-normal text-[0.938rem] leading-none`}>Approval Date</div>
              <div className={`border-[#CECECE] border rounded-md text-[0.938rem] mt-2 pl-4 py-2.5 h-[42px] font-normal text-[#222222] w-full bg-[#F6F6F6]`}>{po.approvedDate? moment.utc(po.approvedDate).local().format(`MM/DD/YYYY`): '--'}</div>
            </div>

            <h4 className='font-semibold text-[0.938rem] pt-4 pb-4 uppercase'>Related Purchase Request</h4>


            {po.purchaseRequestID ? (
                <div className='mb-4 font-normal text-[0.838rem] leading-5'>
                    <div>Code: <Link target='_blank' className='text-primary font-medium' to={URLS.PURCHASING.REQUEST.LIST + '?open='+po.purchaseRequestID}>{po.purchaseRequestCode}</Link></div>
                    <div>Request By: {po?.requesterName}</div>
                    <div>Request Date: {moment(po.requiredByDate).local().format(`MM/DD/YYYY`)}</div>
                </div>
            ):
            <p className='text-[0.7rem] italic font-normal text-slate-500 mb-4'>No related purchase request</p>
            }

          </div>
          
          <div className='flex justify-end gap-2 flex-shrink-0 border-t border-gray-200 pt-2 sticky bottom-0 bg-white z-10'>
            {mode === 'approve' ? (
              <>
                <Button type="button" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onSubmitAction(3)}>Approve</Button>
                <Button theme="danger" type="button" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onSubmitAction(4)}>Reject</Button>
                <Button theme="secondary" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onCancel()}>Cancel</Button>
              </>
            ) : (
              <>
                {po.statusID === 1 && (
                  <Button type="button" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => {
                    onCancel('sendApproval');
                  }}>Send For Approval</Button>
                )}
                {po.statusID === 2 && (
                  <Button type="button" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => {
                    onCancel('approve');
                  }}>Approve</Button>
                )}
                <Button theme="secondary" childstyle={{ padding: '4px 12px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onCancel()}>Close</Button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewPurchaseOrder;